/**
 * @file 複数ファイルドロップ
 */
'use strict'

import Common from "../../Utils/Common"

/**
 * @classname MultipleFileDrop
 * @classdesc 複数ファイルドロップ
 */
export default class MultipleFileDrop {
	/**
	 * @constructor
	 * @param {object} controller - コントローラー
	 * @param {jQuery} $e - $('.multiple-file-drop-wrap')
	 */
	constructor($e, controller) {
		console.log('MultipleFileDrop.constructor')
		this._$e = $e
		this._controller = controller
		this._$input = this._$e.find('.multiple-file-drop__input')
		this._$inputDummy = this._$e.find('.multiple-file-drop__input--dummy')
		this._$selectedFileNames = this._$e.find('.multiple-file-drop__selected-files')
		this._$clearButton = this._$e.closest('.form-group').find('.multiple-file-drop__clear-button')
		this._acceptedFileExtensions = ['jpg', 'JPG', 'jpeg', 'JPEG', 'gif', 'GIF', 'png', 'PNG', 'pdf', 'PDF', 'xlsx', 'XLSX', 'docx', 'DOCX', 'zip', 'ZIP']
		this._$e.on('dragover', (event) => this.onDragover(event))
		this._$e.on('dragleave', (event) => this.onDragleave(event))
		this._$e.on('drop', (event) => this.onDrop(event))
		this._$e.on('change', (event) => this.onChange(event))
		this._$clearButton.on('click', () => this.onClearButtonClick())
	}


	/**
	 * ドラッグオーバーのコールバック
	 *
	 * @memberof MultipleFileDrop
	 * @param {Event} event - イベント
	 * @return {undefined}
	 */
	onDragover(event) {
		console.log('MultipleFileDrop.onDragover')
		event = event.originalEvent
		event.dataTransfer.dropEffect = 'copy'
		event.preventDefault()
		this._$e.addClass('dragover')
   }


	/**
	 * ドラッグリーブのコールバック
	 *
	 * @memberof MultipleFileDrop
	 * @return {undefined}
	 */
	onDragleave() {
		console.log('MultipleFileDrop.onDragleave')
		this._$e.removeClass('dragover')
	}


	/**
	 * ドロップのコールバック
	 *
	 * @memberof MultipleFileDrop
	 * @param {Event} event - イベント
	 * @return {undefined}
	 */
	onDrop(event) {
		console.log('MultipleFileDrop.onDrop')
		event = event.originalEvent
		event.preventDefault()
		event.stopPropagation()
		this._$e.removeClass('dragover')
		const dataTransfer = new DataTransfer()
		let fileExtensionValidity = true
		Array.prototype.forEach.call(this._$input.prop('files'), (file) => {
			if(this._acceptedFileExtensions.includes(file.name.split('.').slice(-1)[0])) {
				dataTransfer.items.add(file)
			} else {
				fileExtensionValidity = false
			}
		})
		Array.prototype.forEach.call(event.dataTransfer.files, (file) => {
			if(this._acceptedFileExtensions.includes(file.name.split('.').slice(-1)[0])) {
				dataTransfer.items.add(file)
			} else {
				fileExtensionValidity = false
			}
		})
		if (!fileExtensionValidity) {
			Common.showErrorModal(`添付できない形式のファイルが含まれていたため、<br>当該ファイルは添付されませんでした。<br>添付できるファイル形式は以下のとおりです。<br>jpg / png / gif / xlsx / docx / pdf / zip`)
		}
		this._$input.prop('files', dataTransfer.files)
		this._$inputDummy.prop('files', dataTransfer.files)
		console.log(this._$input.prop('files'))
		console.log(this._$inputDummy.prop('files'))
		this.updateFileNameList()
	}


	/**
	 * ファイル変更のコールバック
	 *
	 * @memberof MultipleFileDrop
	 * @param {Event} event - イベント
	 * @return {undefined}
	 */
	onChange(event) {
		console.log('MultipleFileDrop.onChange')
		event.preventDefault()
		event.stopPropagation()
		const dataTransfer = new DataTransfer()
		Array.prototype.forEach.call(this._$inputDummy.prop('files'), file => dataTransfer.items.add(file))
		Array.prototype.forEach.call(this._$input.prop('files'), file => dataTransfer.items.add(file))
		this._$input.prop('files', dataTransfer.files)
		this._$inputDummy.prop('files', dataTransfer.files)
		console.log(this._$input.prop('files'))
		console.log(this._$inputDummy.prop('files'))
		this.updateFileNameList()
	}


	/**
	 * 選択中のファイル名リストを更新
	 *
	 * @memberof MultipleFileDrop
	 * @return {undefined}
	 */
	updateFileNameList() {
		console.log('MultipleFileDrop.onChange')
		this._$selectedFileNames.html('')
		if (this._$inputDummy.prop('files').length) {
			Array.prototype.forEach.call(this._$inputDummy.prop('files'), file => {
				this._$selectedFileNames.append($(`<p>${file.name}</p>`))
			})
		} else {
			this._$selectedFileNames.append($(`<p>ファイルが選択されていません</p>`))
		}
	}


	/**
	 * 選択中のファイルを選択解除する
	 *
	 * @memberof MultipleFileDrop
	 * @return {undefined}
	 */
	onClearButtonClick() {
		console.log('MultipleFileDrop.onClearButtonClick')
		this._$input.val(null)
		this._$inputDummy.val(null)
		console.log(this._$input.prop('files'))
		console.log(this._$inputDummy.prop('files'))
		this.updateFileNameList()
	}
}
